module.exports = __webpack_public_path__ + "img/senha.72a0cbac.png";